module.exports = __webpack_public_path__ + "45ecffcff7792ff15bc9ff43d21222ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/images/ch_grid_8.png
// module id = 135
// module chunks = 1